import * as React from "react";
import LazyImage from "@hooplab/responsive-image/dist/LazyImage";

/*TODO: Fikse need additional loader-problemet*/

interface IProps {
  crop: {
    url: string;
    height: number;
    width: number;
    x: number;
    y: number;
  } | null;
  className?: string;
  queries: any[];
  alt?: string;
  forceCrop?: boolean;
  default: { width: number; ar: "Square" | "FourByThree" | "SixteenByNine" };
}

type ImgixEnv = "production" | "staging";

const ImageFetch = (props: IProps) => {
  const crop = props.crop ? props.crop : { url: "", height: 0, width: 0, x: 0, y: 0 };
  return (
    <React.Fragment>
      <LazyImage
        alt={props.alt}
        className={props.className}
        crop={crop}
        default={props.default}
        queries={props.queries}
        environment={process.env.REACT_APP_IMGIX_ENV as ImgixEnv}
        forceCrop={props.forceCrop}
      />
    </React.Fragment>
  );
};

export default ImageFetch;
